export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_16.3da83a80.jpg";